export default __webpack_public_path__ + "static/media/n-spanish.6055e05c.svg";